import React, { useState } from 'react'
import { FlexColumn } from '@/atoms/FlexContainers'
import { CircleInfoIcon } from '@/atoms/Icons/CircleInfoIcon'
import { CaptionSM } from '@/atoms/Text'
import { usePayItForwardOfferData } from '@/contexts/PayItForwardOffersDataContext'
import { MinimalistFooter } from '@/organisms/MinimalistFooter'
import { useGuildMember } from '@/services/GuildUserService'
import { useTranslate } from '@/utils/translate/translate-client'
import { ExpressGuildUpsell } from '@/views/ExpressCheckoutView/components/ExpressGuildUpsell'
import ExpressOffers from '@/views/ExpressCheckoutView/components/ExpressOffers'
import { ExpressPaymentMethods } from '@/views/ExpressCheckoutView/components/ExpressPaymentMethods'
import { ExpressPerks } from '@/views/ExpressCheckoutView/components/ExpressPerks'
import { CheckoutLegalTerms } from '@/views/PayItForward/PayItForwardProjectCheckoutOfferView/CheckoutLegalTerms'
import { getPerksDisclaimerText, hasGuildUpsell } from '../utils'
import { ExpressHeader } from './ExpressHeader'

interface ExpressCheckoutViewProps {
  locale: string
  projectSlug: string
  projectName: string
  theatricalRegion?: string
}

export const ExpressCheckoutView: React.FC<ExpressCheckoutViewProps> = ({
  projectSlug,
  projectName,
  theatricalRegion,
}) => {
  const [isGuildMembershipAdded, setIsGuildMembershipAdded] = useState(false)
  const { t } = useTranslate('pif')

  const { selectedOffer } = usePayItForwardOfferData()
  const { isGuildMember } = useGuildMember()
  const perksDisclaimerText = getPerksDisclaimerText(projectSlug, t)

  return (
    <>
      <div className="bg-core-gray-100">
        <FlexColumn className="relative mx-auto max-w-[640px] gap-6 px-6 pb-16 pt-8 transition-all duration-100 ease-in-out">
          <ExpressHeader projectName={projectName} isDarkMode={false} />
          <ExpressOffers />
          <ExpressPerks theatricalSlug={projectSlug} guildMembershipIncluded={isGuildMembershipAdded} />

          {perksDisclaimerText && (
            <div className="inline-flex items-start gap-1">
              <CircleInfoIcon size={16} color="core-gray-950" className="shrink-0" />
              <CaptionSM color="core-gray-950" italic className="text-pretty">
                {perksDisclaimerText}
              </CaptionSM>
            </div>
          )}

          {!isGuildMember && hasGuildUpsell(projectSlug) && (
            <ExpressGuildUpsell projectSlug={projectSlug} onChange={(val) => setIsGuildMembershipAdded(val)} />
          )}

          {selectedOffer && (
            <ExpressPaymentMethods
              projectSlug={projectSlug}
              selectedOffer={selectedOffer}
              isGuildMembershipAdded={isGuildMembershipAdded}
              theatricalRegion={theatricalRegion}
            />
          )}

          <CheckoutLegalTerms className="text-center !text-black" />
        </FlexColumn>
      </div>
      <MinimalistFooter className="!pb-12" />
    </>
  )
}
